
(function($) {
    "use strict";

	jQuery(document).ready(function(){

      var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry)/i);
      
	
//     if(isMobile){
//       $('.desktop-section').remove();
//     }else{
//       $('.mobile-section').remove();
//     }
	/*-----
    	 jQuery MeanMenu
    -------------------*/
      jQuery('nav#dropdown').meanmenu({
      	meanScreenWidth: "991"
      });
      
  
   /*   Nivo Slider
    -----------------------------------*/

    if(isMobile){
      $('#home-slider-mobile').nivoSlider({

         directionNav: true,
          animSpeed: 1000,
          effect: 'Normal',
          slices: 18,
          pauseTime: 3000, //88885000
          pauseOnHover: false,
          controlNav: false,
          prevText: '<img src="https://cdn.shopify.com/s/files/1/0611/2454/2703/t/4/assets/back.png" loading="lazy" class="laxyload" width="25" height="25">',
          nextText: '<img src="https://cdn.shopify.com/s/files/1/0611/2454/2703/t/4/assets/next.png" loading="lazy" class="laxyload" width="25" height="25">'
      });

     }else{
        $('#home-slider').nivoSlider({

         directionNav: false,
          animSpeed: 1000,
          effect: 'fade',
          slices: 18,
          pauseTime: 3000, //88885000
          pauseOnHover: false,
          controlNav: false,
          prevText: '<img src="https://cdn.shopify.com/s/files/1/0611/2454/2703/t/4/assets/back.png" loading="lazy" class="laxyload" width="25" height="25">',
          nextText: '<img src="https://cdn.shopify.com/s/files/1/0611/2454/2703/t/4/assets/next.png" loading="lazy" class="laxyload" width="25" height="25">'

      });
     }
  
    /*---
    	 wow js active
    ------------- */
    new WOW().init();
    
    
    /*------
       stickey menu
    ----------------*/
    $(window).on('scroll',function() {    
	   var scroll = $(window).scrollTop();
	   if (scroll < 265) {
		$(".sticky-header").removeClass("sticky");
	   }else{
		$(".sticky-header").addClass("sticky");
           }
    });
    
    /*--
    
    
    /*-----
		05. Isotope activation
	------------------*/
      if(!isMobile){
    $(window).on('load',function(){

        // Activate isotope in container
        $(".product-filter").isotope({
           itemSelector:'.filter-item'
        });

        //add isotope click function
        $('.product-filter-menu li').on('click',function(){
           $(".product-filter-menu li").removeClass("active");
           $(this).addClass("active");

           var selector = $(this).attr("data-filter");
         $(".product-filter").isotope({
             filter: selector,
             animationOptions:{
                 duration:750,
                 easing:'linear',
                 queue: false
             }
         });
         return false;
        });

    });
      
      }

    
    /*-----
        portfolio item 2 activation
    ---------------------*/
    
    $('.grid').imagesLoaded( function() {

        // filter items on button click
        $('.portfolio-menu').on( 'click', 'button', function() {
          var filterValue = $(this).attr('data-filter');
          $grid.isotope({ filter: filterValue });
        });	

        // init Isotope
        var $grid = $('.grid').isotope({
          itemSelector: '.grid-item',
          percentPosition: true,
          masonry: {
            // use outer width of grid-sizer for columnWidth
            columnWidth: 1
          }
        });
    
    });
    
    /*------
        portfolio item 3 activation
    ------------------*/
    
    $('.grid-2').imagesLoaded( function() {

        // filter items on button click
        $('.portfolio-menu').on( 'click', 'button', function() {
          var filterValue = $(this).attr('data-filter');
          $grid.isotope({ filter: filterValue });
        });	

        // init Isotope
        var $grid = $('.grid-2').isotope({
          itemSelector: '.grid-item',
          percentPosition: true,
          masonry: {
            // use outer width of grid-sizer for columnWidth
            columnWidth: '.grid-item'
          }
        });
    
    });
    $('.portfolio-menu button').on('click', function(event) {
        $(this).siblings('.active').removeClass('active');
        $(this).addClass('active');
        event.preventDefault();
    });
        
    /*------
      Counter Up
    -------------- */	
    $('.counter').counterUp({
        delay: 70,
        time: 5000
    });
    /* magnificPopup video popup */
        // if(!isMobile){
        //   $('.video-play a').magnificPopup({
        //       type: 'iframe'
        //   });
        // }
    
    /* magnificPopup image popup */
    /*$('.single-portfolio a').magnificPopup({
        type: 'image',
        gallery:{
            enabled:true
        }
    });*/
    /*------
      slider active
    ---------------- */  
     
   
     
    $(".portfolio-slide").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:false,
	  navigation:true,	  
      items : 1,
      navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      itemsDesktop : [1199,1],
	  itemsDesktopSmall : [991,1],
	  itemsTablet: [767,1],
	  itemsMobile : [479,1],
    });
     
    /*--
        Testimonial Slider
    -----------------*/
  
    
   
    
    
    /*--
    Product Quantity
    -----------------------------------*/
   
    

     /*-------------------------------------------
    	scrollUp jquery active
    --------------------------------------------- */
    // $.scrollUp({
    //     scrollText: '<i class="zmdi zmdi-long-arrow-up"></i>', 
    //     easingType: 'linear',
    //     scrollSpeed: 900,
    //     animation: 'fade'
    // });
      
    
    /* Mega Menu */
//    $('.mega-menu-li').parent('ul').addClass('mega-menu');
      
    
    /* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 
      
      
    });
  
  

})(jQuery);


